module.exports = __webpack_public_path__ + "img/c06_unittechroyalgarden_Normal_ua.3f450942.webp";